import { TextField, MenuItem, Radio, RadioGroup, FormControlLabel } from "@material-ui/core"

export default function WorkingWithBroker() {
  return (
    <React.Fragment>
      <fieldset>
        <legend className="quoteform__heading">Are you working with a broker?</legend>
        <div className="quoteform__grid">
          <div className="quoteform__input">
            <TextField name="resale-company" select fullWidth label="Resale Company" variant="outlined" autoComplete="resale-off">
              <MenuItem value="">No broker</MenuItem>
              <MenuItem value="DVC Resale Market">DVC Resale Market</MenuItem>
              <MenuItem value="The Timeshare Store">The Timeshare Store</MenuItem>
              {/* <MenuItem value="Resales DVC">Resales DVC</MenuItem> */}
              <MenuItem value="Vacation Club Life">Vacation Club Life</MenuItem>
              <MenuItem value="DVC Shop">DVC Shop</MenuItem>
              <MenuItem value="DVC Magic Resales">DVC Magic Resales</MenuItem>
              <MenuItem value="DVC by Resale">DVC by Resale</MenuItem>
              <MenuItem value="DVC Resale Experts">DVC Resale Experts</MenuItem>
              <MenuItem value="Fidelity">Fidelity</MenuItem>
              <MenuItem value="DVC Sales">DVC Sales</MenuItem>
              <MenuItem value="Buy and Sell DVC">Buy and Sell DVC</MenuItem>
              <MenuItem value="A Timeshare Broker">A Timeshare Broker</MenuItem>
              <MenuItem value="Vacatia">Vacatia</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </TextField>
          </div>
          <div className="quoteform__input">
            <TextField name="resale-agent" fullWidth label="Name of Agent" variant="outlined" autoComplete="agent-off" />
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend className="quoteform__heading quoteform__heading--noMargin">Do you have an accepted offer?</legend>
        <div className="quoteform__input quoteform__input--noMargin">
          <RadioGroup name="accepted-offer" defaultValue="no">
            <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
            <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
          </RadioGroup>
        </div>
      </fieldset>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/components/WorkingWithBroker.js